import Box from "../../components/Box";

import Radio from "../../components/Radio";
import Typography from "../../components/Typography";
import { RoleTab } from "../../constants/enums";

const RoleTabComponent = ({
    tab,
    setTab,
    disabled,
    backgroundColor,
}: {
    tab: RoleTab;
    setTab: React.Dispatch<React.SetStateAction<RoleTab>>;
    disabled?: boolean;
    backgroundColor?: string;
}) => {
    return (
        <Box
            sx={{
                backgroundColor: backgroundColor ? backgroundColor : "#ffffff",
                borderRadius: 2,
                display: "flex",
                gap: 1,
                m: 0,
                alignItems: "center",
            }}
        >
            <Tab label="Vai trò" onChangeTab={setTab} tab={RoleTab.Role} isActive={tab === RoleTab.Role} disabled={disabled} />
            <Tab label="Phân quyền" onChangeTab={setTab} tab={RoleTab.Policy} isActive={tab === RoleTab.Policy} disabled={disabled} />
        </Box>
    );
};

const Tab = ({
    label,
    onChangeTab,
    isActive,
    tab,
    disabled,
}: {
    label: string;
    onChangeTab: (tab: RoleTab) => void;
    isActive: boolean;
    tab: RoleTab;
    disabled: boolean;
}) => {
    const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (disabled) return;
        e.stopPropagation();
        onChangeTab(tab);
    };
    return (
        <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={({ palette: { info } }) => ({
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderBottom: "2px solid transparent",
                px: 2,
                py: 1,
                transition: "border-bottom .3s ease-out",
                ...(isActive && {
                    borderBottomColor: info.main,
                }),
                ...(!disabled && {
                    "&:hover": {
                        cursor: "pointer",
                    },
                }),

                ...(disabled && {
                    filter: "grayscale(1)",
                }),
            })}
            onClick={onClick}
        >
            {/* <Radio checked={isActive} onClick={onClick} disabled={disabled} /> */}
            <Typography variant="caption">{label}</Typography>
        </Box>
    );
};

export default RoleTabComponent;
